import {FormValuesProps} from "../../modals/notificationModals/NewNotificationModal";
import "./step4.css";
import Celebration from "../../../assets/illustrations/celebration.png";
import {RightOutlined} from "@ant-design/icons";
import {Button} from "antd";

interface Step4Props {
    onClose: () => void;
    formValues: Partial<FormValuesProps>;
    isPresets?: boolean;
    isFlowCreation?: boolean;
    isCampaign?: boolean;
}

const Step4 = ({ onClose, formValues: { title }, isCampaign = false, isPresets = false, isFlowCreation = false }: Step4Props) => {
    return (
        <div className="step-container step-4">
            <div className="celebration-text">
                Great job, you've successfully created {isFlowCreation ? `a new ${isCampaign ? 'Campaign' : 'Automation'}` : isPresets ? title : `"${title}"`}!
            </div>
            <img src={Celebration} className="celebration-image" />
            <Button type="primary" size="large" className="done-button" onClick={onClose} >Return to your {isFlowCreation ? isCampaign ? 'Campaigns' : 'Automations' : isCampaign ? 'Campaigns' : 'Templates'}</Button>
        </div>
    );
}

export default Step4;